// extracted by mini-css-extract-plugin
module.exports = {"core":"User-core-3B0UF"};